module.exports = __webpack_public_path__ + "img/PLOS.2b3e2190.jpg";